var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThroughputs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93334 23.4732L1.65234 20.6192C2.99025 17.5939 5.17738 15.0219 7.94836 13.2153C10.7193 11.4087 13.9551 10.4451 17.263 10.4414C20.5709 10.4377 23.8087 11.394 26.5838 13.1944C29.3588 14.9948 31.5517 17.5619 32.8963 20.5841L26.5503 23.4092C25.7518 21.6177 24.4515 20.0958 22.8067 19.0273C21.1618 17.9588 19.2428 17.3895 17.2813 17.3882C15.3032 17.3969 13.3695 17.9755 11.7117 19.0547C10.0538 20.1338 8.74203 21.6679 7.93334 23.4732Z",
    stroke: "#EBEDF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4865 10.6901L17.4775 13.1131",
    stroke: "#EBEDF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5957 15.9461L6.6477 17.7111",
    stroke: "#EBEDF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 12.4711L23.709 14.6461",
    stroke: "#EBEDF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5542 24.8172C17.9139 24.847 18.2744 24.7694 18.5901 24.5944C18.9058 24.4193 19.1624 24.1546 19.3276 23.8336C19.4928 23.5126 19.5591 23.1499 19.5182 22.7913C19.4772 22.4326 19.3308 22.0942 19.0975 21.8188C18.8641 21.5433 18.5544 21.3433 18.2074 21.2439C17.8603 21.1445 17.4916 21.1503 17.1479 21.2605C16.8041 21.3707 16.5008 21.5804 16.2762 21.863C16.0516 22.1456 15.9159 22.4884 15.8862 22.8482C15.8663 23.087 15.8937 23.3274 15.9668 23.5556C16.0399 23.7838 16.1572 23.9954 16.3121 24.1783C16.467 24.3612 16.6565 24.5117 16.8696 24.6213C17.0827 24.7309 17.3153 24.7975 17.5542 24.8172V24.8172Z",
    stroke: "#EBEDF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9542 14.0021L18.4912 21.3501",
    stroke: "#EBEDF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4589 14.3541L10.4189 12.1812",
    stroke: "#EBEDF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1768 20.7984L26.7058 22.9984L32.7468 20.5864L29.9168 16.4704L25.1768 20.7984Z",
    fill: "#EBEDF0",
    stroke: "#EBEDF0",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThroughputs);
export default __webpack_public_path__ + "static/media/Throughputs.732d0c43.svg";
export { ForwardRef as ReactComponent };